<template lang="pug">
.sendmessage-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ cancel }")
      .sendmessage-modal-header
        .d-flex.flex-row
          .title.flex-fill {{ _title }}
          .buttons.mr-2
            button.btn.index-btn(@click="prevFile()" :class="{ disable: disabledPrevButton }" :disabled="disabledPrevButton") ＜ 前へ
            button.btn.index-btn(@click="nextFile()" :class="{ disable: disabledNextButton }" :disabled="disabledNextButton") 次へ ＞
      button(type="button" class="close" @click="cancel()") ×
    .sendmessage-modal-body
      div(v-if="files && 0 < files.length")
        div(v-show="_mime == 'image/jpeg'")
          img(:src="getImage()")
        div(v-show="_mime == 'video/mp4'")
          video(playsinline autoplay muted loop ref="videomp4" v-show="canPlay" :src="getVideo()" type="video/mp4" controls)
        div(v-show="_mime == 'video/quicktime'")
          video(playsinline autoplay muted loop ref="videomov" v-show="canPlay" :src="getQuickTimeVideo()" type="video/quicktime" controls)
        // v-ifにしないとdataの書き換えが行われないのでv-ifを使用する
        div(v-if="_mime == 'application/pdf'")
          object.pdf(:data="getPdf()" type="application/pdf")
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

/**
 * メッセージ送信添付ファイルプレビューモーダル
 *
 */
@Component
export default class SendDocumentFilesPreviewModal extends Vue {
  @Ref() videomp4!: Element;
  @Ref() videomov!: Element;

  /** 表示可否 */
  @Prop()
  value!: boolean;
  /** ファイル */
  @Prop()
  files!: Array<SendDocumentFilesPreviewModalItem>;

  /** 選択しているファイルのindex */
  index: number = 0;
  /** 表示対象ファイルのURL */
  fileUrl: string = "";
  /** 再生可能か */
  canPlay: boolean = false;

  get _value(): boolean {
    // 表示のタイミングでindexを初期化する
    if (this.value == true) {
      this.index = 0;
    }
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _title(): string {
    if (!this.files || this.files.length < 1) {
      return "";
    }
    const file: SendDocumentFilesPreviewModalItem = this.files[this.index];
    return `${file.groupName}・${file.roomName}・${file.residentName}`;
  }

  get _mime(): string {
    if (!this.files || this.files.length < 1) {
      return "";
    }
    if (!this.files[this.index] || !this.files[this.index].file) {
      return "";
    }
    return this.files[this.index].file.type;
  }

  get disabledPrevButton(): boolean {
    if (this.index == 0) {
      return true;
    } else {
      return false;
    }
  }

  get disabledNextButton(): boolean {
    if (this.files.length <= this.index + 1) {
      return true;
    } else {
      return false;
    }
  }

  public async getImage(): Promise<string> {
    return await this.encodeImage(this.files[this.index].file);
  }

  /**
   * ### ファイルをBase64エンコードする
   */
  public async encodeImage(file: File): Promise<string> {
    const fileUrl: string = await FileReaderWrapper.readAsDataURL(file);
    return fileUrl;
  }

  public getVideo(): void {
    this.setVideoObject(this.videomp4, this.files[this.index].file);
    return;
  }

  public getQuickTimeVideo(): void {
    this.setVideoObject(this.videomov, this.files[this.index].file);
    return;
  }

  /**
   * ### video要素に指定されたvideoを設定する
   */
  public setVideoObject(video: Element, file: any): void {
    if (video instanceof Element) {
      video.addEventListener(
        "canplay",
        () => {
          this.canPlay = true;
        },
        false
      );
      this.canPlay = false;
      this.fileUrl = "";
      this.fileUrl = this.convertObjectUrl(file);
    }
    return;
  }

  public getPdf(): string {
    return this.convertObjectUrl(this.files[this.index].file);
  }

  /**
   * ### ファイルからObjectを作る
   */
  public convertObjectUrl(file: File): string {
    const fileUrl: string = window.URL.createObjectURL(file);
    return fileUrl;
  }

  /**
   * ### ファイル戻る
   */
  public async prevFile() {
    this.index--;
    return;
  }

  /**
   * ### ファイル次へ
   */
  public async nextFile() {
    this.index++;
    return;
  }
}

export interface SendDocumentFilesPreviewModalItem {
  groupName: string;
  roomName: string;
  residentName: string;
  file: File;
}
</script>
<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.pdf {
  width: 100%;
  height: 83vh;
}
</style>
